import { ScriptLdJson } from "@/lib/scripts/ScriptLdJson"
import { type VideoObject, type WithContext } from "schema-dts"

export interface VideoObjectInput {
    name?: string
    description?: string
    uploadDate?: string
    canonicalUrl?: string
    thumbnailUrl?: string
    contentUrl?: string
}

export function buildVideoObject({
    name,
    description,
    uploadDate,
    canonicalUrl,
    thumbnailUrl,
    contentUrl
}: VideoObjectInput): WithContext<VideoObject> | null {
    const url = canonicalUrl?.trim()
    const playbackUrl = contentUrl?.trim()

    if (!name || !description || !uploadDate || !thumbnailUrl || !url) {
        return null
    }

    return {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name,
        description,
        thumbnailUrl,
        uploadDate,
        url,
        ...(playbackUrl ? { contentUrl: playbackUrl } : {})
    }
}

export function generateVideoObjectLdJson(input: VideoObjectInput, id: string) {
    const jsonLd = buildVideoObject(input)

    if (!jsonLd) {
        return null
    }

    return ScriptLdJson<VideoObject>(jsonLd, id)
}
